import { PATH } from '#const/path';
import useQueryParamURL from '#hooks/useQueryParamURL';

/**
 * 스케쥴 등록페이지의 url 반환
 */
export default function useScheduleRegistrationUrl(
  params: Record<string, string> = {}
) {
  const url = useQueryParamURL({
    pathname: PATH.Weekly_Calender_Schedule_Registration,
    params: {
      ...params
    },
    replaceParams: true
  });

  return url;
}
